import { render, staticRenderFns } from "./CookieConsent.vue?vue&type=template&id=f2f4afc4&scoped=true&"
import script from "./CookieConsent.vue?vue&type=script&lang=js&"
export * from "./CookieConsent.vue?vue&type=script&lang=js&"
import style0 from "./CookieConsent.vue?vue&type=style&index=0&id=f2f4afc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f4afc4",
  null
  
)

export default component.exports